export default __webpack_public_path__ + "static/media/ic-call-us.5597bc21.svg";